export const darkTheme = {
  bg: "#07071A",
  bgLight: "#0F0F2E",
  primary: "#22D3EE",
  primary_light: "rgba(34, 211, 238, 0.08)",
  text_primary: "#E2E8F0",
  text_secondary: "#94A3B8",
  card: "#0B0B24",
  card_light: "#111136",
  button: "#22D3EE",
  border: "rgba(34, 211, 238, 0.1)",
  white: "#FFFFFF",
  black: "#000000",
}

export const lightTheme = {
  bg: "#FFFFFF",
  bgLight: "#F1F5F9",
  primary: "#0891B2",
  primary_light: "rgba(8, 145, 178, 0.08)",
  text_primary: "#0F172A",
  text_secondary: "#475569",
  card: "#F8FAFC",
  card_light: "#F1F5F9",
  button: "#0891B2",
  border: "rgba(8, 145, 178, 0.12)",
  white: "#FFFFFF",
  black: "#000000",
}
